import React, {useContext, useState} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, UpdateTipUrl} from "../CommonComponents/Routes";

export default (props) => {
    let Record = useContext(RecordsManagementContext)
    const [PercentageTip, setPercentageTip] = useState(Record.CP_PageDetails.PercentageTip)
    const [TipAmount, setTipAmount] = useState('')

    const validateTipAmount = (e) => {
        let regex = /^\d+(\.\d+)?%?$/
        let new_value = e.target.value
        if (regex.test(new_value) || new_value == '') {
            setTipAmount(new_value)
        }
    }

    const radioClick = (e) => {
        axios({method: 'post', url: UpdateTipUrl, params: {tip: e.target.value, estimate_key: Elink, employee_key: document.cookie.split('employee_id=')[1]}}).then((response) => {
            props.NewTotalCost(response.data[0].toString())
            props.NewBalanceDue(response.data[1].toString())
            setTipAmount(e.target.value)
            props.hideCrewTipModal()
            props.Tip(response.data[2].toString())
            props.TipValue(e.target.value)
            props.FormatVisible(true)
        })
    }

    const tipSubmit = () => {
        axios({method: 'post', url: UpdateTipUrl, params: {tip: TipAmount, estimate_key: Elink, employee_key: document.cookie.split('employee_id=')[1]}}).then((response) => {
            props.NewTotalCost(response.data[0].toString())
            props.NewBalanceDue(response.data[1].toString())
            props.hideCrewTipModal()
            props.TipValue(TipAmount)
            props.Tip(response.data[2].toString())
            props.FormatVisible(true)
        })
    }

    return (
        <>
            {PercentageTip ? <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <input type="radio" value="10%" name="10%" onClick={radioClick} style={{marginLeft: '20px'}}/>
                    <span style={{paddingLeft: '2px'}}>10%</span>
                    <input type="radio" value="15%" name="15%" onClick={radioClick} style={{marginLeft: '30px'}}/>
                    <span style={{paddingLeft: '2px'}}>15%</span>
                    <input type="radio" value="20%" name="20%" onClick={radioClick} style={{marginLeft: '30px'}}/>
                    <span style={{paddingLeft: '2px'}}>20%</span>
                    <input type="radio" value="others" name="others" style={{marginLeft: '30px'}}
                           onClick={(e) => setPercentageTip(false)}/>
                    <span style={{paddingLeft: '2px'}}>Others</span><br/><br/>
                </div> :
                <>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <input
                            type="text"
                            style={{
                                width: '10rem',
                                border: '2px solid black',
                                padding: '7px',
                            }}
                            value={TipAmount}
                            onChange={validateTipAmount}
                        />
                    </div>
                    <br/>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button className='btn btn-dark' onClick={tipSubmit} >SUBMIT</button>
                    </div>
                </>
            }
        </>
    )
}

